import React, { useEffect, useState, memo } from 'react';
import { useDispatch } from "react-redux";
import { setFetching } from '../../redux/states';
import { useErrorSetter } from '../../hooks/useUiMessages';
import { examSimulatorPricing } from '../UI/SubscriptionPlans/data.js'
import { ModalContainerMobile } from '../../styled/Modal';
import Modal from '../UI/SubscriptionPlans/Modal';
import { fetchPrice, fetchCurrency } from '../../utils/client-functions';


const ExamPricing = ({closePricing, open}) => {
    const dispatch = useDispatch()
    const [pricePerWeek, setPricePerWeek] = useState(0)
    const [pricePerMonth, setPricePerMonth] = useState(0)
    const [currency, setCurrency] = useState('')

    const errorSetter = useErrorSetter();

    useEffect(() => {
        if (!open) return;

        dispatch(setFetching(true))
        const fetchData = async () => {
            try {
                const pricePerWeek = await fetchPrice('exam', 'priceTwo') // Student Plan
                const pricePerMonth = await fetchPrice('exam', 'priceThree') // Pro Plan
                const userCurrency = await fetchCurrency()
                setPricePerWeek(pricePerWeek)
                setPricePerMonth(pricePerMonth)
                setCurrency(userCurrency)
                sessionStorage.setItem('prevPath', window.location.pathname);
    
                dispatch(setFetching(false))
            } catch (error) {
                errorSetter('Error fetching country prices, please reload page')
            }

        }
        fetchData()
    }, [dispatch, open, errorSetter])

    if (!open) return null;

    const examPricingDetails = examSimulatorPricing(pricePerWeek, pricePerMonth, currency);


    return (
        <ModalContainerMobile>
            <Modal plan={examPricingDetails} title="Exam Simulator" open={true} setOpen={closePricing} />
        </ModalContainerMobile>
    )
}


export default memo(ExamPricing);
